// View Switcher Component
// Date: December 4, 2025
// Purpose: Toggle between table and card views

import React from 'react';
import { 
  TableCellsIcon,
  Squares2X2Icon
} from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/Button';

export type ViewMode = 'table' | 'cards';

export interface ViewSwitcherProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  className?: string;
}

export const ViewSwitcher: React.FC<ViewSwitcherProps> = ({
  currentView,
  onViewChange,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-1 bg-[var(--color-secondary-bg)] rounded-lg p-1 ${className}`}>
      <Button
        variant={currentView === 'table' ? 'primary' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('table')}
        className="flex items-center gap-2"
        title="Table View"
      >
        <TableCellsIcon className="w-4 h-4" />
        <span className="hidden sm:inline">Table</span>
      </Button>
      <Button
        variant={currentView === 'cards' ? 'primary' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('cards')}
        className="flex items-center gap-2"
        title="Card View"
      >
        <Squares2X2Icon className="w-4 h-4" />
        <span className="hidden sm:inline">Cards</span>
      </Button>
    </div>
  );
};

